import React from "react";
var EmptyBox = function EmptyBox(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 1v22h-1.5V1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.695.315l-9 4a.75.75 0 00-.06 1.34l9 5a.75.75 0 00.73 0l9-5a.75.75 0 00-.06-1.34l-9-4a.75.75 0 00-.61 0zM12 1.82l7.321 3.254L12 9.142 4.678 5.074 12 1.82z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.75 5v12a.75.75 0 01-.25.559l-.084.065-9 6a.75.75 0 01-.734.055l-.098-.055-9-6a.75.75 0 01-.326-.518L2.25 17v-6h1.5v5.598l8.249 5.499 8.251-5.5V5h1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.304 4.721l-2 5a.75.75 0 00.332.935l9 5a.75.75 0 001.06-.377l2-5a.75.75 0 00-.332-.935l-9-5a.75.75 0 00-1.06.377zM3.38 6.07l7.678 4.265-1.439 3.596-7.678-4.265L3.38 6.069zM20.25 5v4c0 .284.16.544.415.67l2 1c.616.31 1.287-.308 1.031-.949l-2-5c-.306-.766-1.446-.547-1.446.279z"
  }));
};
EmptyBox.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
import createIconComponent from '../createIconComponent';
export const EmptyBoxIcon = createIconComponent(EmptyBox, 'EmptyBox');